


export default function MasterCreation()
{
    return(
        <>
        
        </>
    )
}